/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { HeartIcon16Light } from './HeartIcon16Light';
import { HeartIcon16Regular } from './HeartIcon16Regular';
import { HeartIcon16Solid } from './HeartIcon16Solid';
import { HeartIcon20Light } from './HeartIcon20Light';
import { HeartIcon20Regular } from './HeartIcon20Regular';
import { HeartIcon20Solid } from './HeartIcon20Solid';
import { HeartIcon24Regular } from './HeartIcon24Regular';
import { HeartIcon24Solid } from './HeartIcon24Solid';
import { HeartIcon32Regular } from './HeartIcon32Regular';
import { HeartIcon64Regular } from './HeartIcon64Regular';
var sizes = {
    16: {
        light: HeartIcon16Light,
        regular: HeartIcon16Regular,
        solid: HeartIcon16Solid,
    },
    20: {
        light: HeartIcon20Light,
        regular: HeartIcon20Regular,
        solid: HeartIcon20Solid,
    },
    24: {
        regular: HeartIcon24Regular,
        solid: HeartIcon24Solid,
    },
    32: {
        regular: HeartIcon32Regular,
    },
    64: {
        regular: HeartIcon64Regular,
    },
};
export var HeartIcon = forwardRef('HeartIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
